import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  href?: string;
  label?: string;
  subLabel?: string;
  location?: string;
  className?: string;
};
export function CtaButton({
  href = CHECKOUT_URL,
  label = '🚗 ¡SÍ, QUIERO PROTEGER MI AUTO Y MI BOLSILLO POR $19.900!',
  subLabel,
  location = 'landing',
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Método Mecánica Inteligente',
      content_category: location,
      currency: 'ARS',
      value: PRICE
    });
  };
  return <div className={`w-full ${className}`} data-id="element-14" data-mp="vbk05oqcjaxc">
      <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 26
    }} className="group flex w-full items-center justify-center rounded-lg bg-amber-brand px-6 py-5 text-center font-display text-xl font-bold uppercase leading-tight tracking-wide text-ink-950 shadow-cta ring-1 ring-amber-brand/60 transition-colors hover:bg-[#ffb733] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-amber-brand sm:text-2xl" data-id="element-15" data-mp="vbsg5phrmwcr">
        <span data-id="element-16" data-mp="3owtkvwlggu4h">{label}</span>
      </motion.a>
      {subLabel ? <p className="mt-3 text-center text-sm text-white/50" data-id="element-17" data-mp="3sxlw2vdw193e">{subLabel}</p> : null}
    </div>;
}